export default {
  'reports.title': 'Reportes',
  'reports.button.open': 'Abrir',
  'reports.builder.notPublished': 'Este reporte aún no está publicado',
  'reports.builder.notPublished.description':
    'Publica una versión para que los usuarios puedan verlo.',
  'reports.builder.new.title': 'Nuevo reporte',
  'reports.builder.preview.empty': 'Tu reporte comienza aquí',
  'reports.builder.preview.empty.description': 'Descríbelo en el chat para construirlo paso a paso',
  'reports.builder.preview.empty.hint': 'Escribe en el chat para comenzar',
  'reports.builder.sidebar.overview': 'Vista general',
  'reports.builder.section.accessControl': 'Control de acceso',
  'reports.builder.chat': 'Asistente',
  'reports.builder.chat.title': 'Asistente IA',
  'reports.builder.chat.open': 'Abrir asistente',
  'reports.builder.chat.close': 'Cerrar asistente',
  'reports.builder.code': 'Código',
  'reports.builder.code.empty': 'Todavía no hay code.js ni code.css en este borrador.',
  'reports.builder.code.emptyFile': 'Este archivo no tiene contenido.',
  'reports.manageReports.title': 'Gestionar Reportes',
  'reports.tab.groups': 'Grupos',
  'reports.tab.favorites': 'Favoritos',

  'reports.manageGroups.components.powerBIServerConfigurationId': 'Configuración Servidor Power BI',
  'reports.manageGroups.components.powerBIReportGroupId': 'Id Grupo de PowerBI',
  'reports.manageGroups.components.powerBIReportId': 'Id Reporte PowerBI',
  'reports.manageGroups.components.menuTitle': 'Titulo del Menú',
  'reports.manageGroups.components.menuTooltip': 'Texto de ayuda del Menú',
  'reports.manageGroups.components.textHelp': 'Texto de ayuda del Menú',
  'reports.manageGroups.components.asLink': 'Mostrar como Vínculo',
  'reports.manageGroups.components.powerBIConnector': 'Conector de Power BI',

  'reports.manageReports.components.report-group': 'Grupo de Reportes',
  'reports.manageReports.components.tagLink': 'Etiquetas de Rlasificación del Reporte',
  'reports.manageReports.components.multiplePages': '¿Múltiples páginas?',
  'reports.manageReports.components.defaultReport': 'Sección del Report Predeterminada',
  'reports.manageReports.components.enableDataFilter':
    '¿Habilitar Filtro de Datos de Reporte por Usuario?',
  'reports.manageReports.components.reportFilter':
    '¿Habilitar Filtro de datos de Reporte por Usuario?',

  'reports.manageReports.components.reportId': 'Id Reporte PowerBI',
  'reports.manageReports.components.datasetId': 'Id Dataset PowerBI',
  'reports.manageReports.components.defaultReportSection': 'Sección del Reporte Predeterminada',
  'reports.manageReports.components.isMultipage': '¿Múltiples Páginas?',
  'reports.manageReports.components.isReportDataFilterByUserEnabled':
    '¿Habilitar Filtro de Datos de Reporte por Usuario?',
  'reports.manageReports.components.isReportDataFilterByPositionEnabled':
    '¿Filtro de Datos de Reporte por Puesto?',
  'reports.platform': 'Plataforma',

  'reports.manageReports.components.reportDataFilterUserTableName':
    'Nombre de Tabla para Filtro por Usuario',
  'reports.manageReports.components.reportDataFilterUserFieldName':
    'Nombre de Campo para Filtro por Usuario',
  'reports.manageReports.components.reportDataFilterUserFieldNameInternal':
    'Nombre Interno de Campo para Filtro por Usuario',
  'reports.manageReports.components.reportDataFilterPositionTableName':
    'Nombre de Tabla para Filtro por Puesto',
  'reports.manageReports.components.reportDataFilterPositionFieldName':
    'Nombre de Campo para Filtro por Puesto',
  'reports.manageReports.components.reportDataFilterPositionFieldNameInternal':
    'Nombre Interno de Campo para Filtro por Puesto',
  'reports.operador.or': 'Or',
  'reports.operador.and': 'And',
  'reports.permissionsFiltersLogicalOperator': 'Operador Lógico Permisos',

  'reports.type.administration': 'Administración',
  'reports.type.process': 'Proceso',
  'reports.type.request': 'Solicitud',
  'reports.type.generic': 'Genérico',
  'reports.type.powerbiconnector': 'Conector Power BI',

  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Movil',
  'reports.platform.webmobile': 'WebMovil',

  'reports.export.title': 'Exportar reporte',
  'reports.export.pdf': 'Exportar como PDF',
  'reports.export.pptx': 'Exportar como PowerPoint',
  'reports.export.requestSent':
    'Solicitud de exportación enviada. Recibirás una notificación cuando esté lista.',
  'reports.export.generating': 'Generando...',
  'reports.export.inProgress': 'Generando',
  'reports.export.ready': 'Archivo listo para descargar',
  'reports.export.error': 'Error al generar el archivo',
  'reports.export.failed': 'Error',
  'reports.fullscreen': 'Pantalla completa',
  'reports.exitFullscreen': 'Salir de pantalla completa',
  'reports.detail.back': 'Volver',
  'reports.detail.refresh': 'Refrescar',
  'reports.detail.configure': 'Configurar',
  'reports.detail.tagline.fallback': 'Visualiza y explora el reporte embebido.',
  'reports.detail.mobile.scrollHint':
    'Desliza en cualquier dirección para explorar el reporte. Usa pantalla completa para verlo mejor.',
  'reports.detail.mobile.gestureHint': 'Toca para usar · Desliza para mover',
  'reports.detail.mobile.zoomIn': 'Acercar reporte',
  'reports.detail.mobile.zoomOut': 'Alejar reporte',
  'reports.detail.notFound': 'El reporte no existe o no se encontró.',
  'reports.detail.loadError': 'No se pudo cargar el reporte.',
  'reports.detail.embedError': 'No se pudo embeber el reporte de Power BI.',
  'reports.detail.pages': 'Páginas del reporte',
  'reports.detail.mobile.pages': 'Páginas del reporte',
  'reports.detail.tab.report': 'Reporte',
  'reports.detail.tab.datasets': 'Dataset',
  'reports.detail.tagline.datasets':
    'Salud, sync y alcance de los datasets que alimentan este reporte.',

  'reports.datasets.loading': 'Cargando el inventario de datasets…',
  'reports.datasets.filter.aria': 'Filtrar datasets',
  'reports.datasets.filter.all': 'Todos',
  'reports.datasets.filter.globals': 'Globales',
  'reports.datasets.filter.process': 'Por proceso',
  'reports.datasets.filter.attention': 'Atención',
  'reports.datasets.section.globals': 'Dimensiones globales',
  'reports.datasets.section.process': 'Datos de proceso',
  'reports.datasets.section.unassigned': 'Sin proceso',
  'reports.datasets.updated': 'actualizado {when}',
  'reports.datasets.processing': 'Sincronizando ahora',
  'reports.datasets.pending': 'Pendiente',
  'reports.datasets.health.healthy': 'Saludable',
  'reports.datasets.health.lagging': 'Con retraso',
  'reports.datasets.health.reconciliationPending': 'Reconciliación pendiente',
  'reports.datasets.health.antiEntropyOverdue': 'Anti-entropía vencida',
  'reports.datasets.health.failed': 'Falló',
  'reports.datasets.health.rebuildRequired': 'Requiere rebuild',
  'reports.datasets.health.noStream': 'Sin stream',
  'reports.datasets.health.unknown': 'Estado',
  'reports.datasets.state.synced': 'Sincronizado',
  'reports.datasets.state.notSynced': 'Sin sync',
  'reports.datasets.state.failed': 'Error de sync',
  'reports.datasets.error.timeout': 'Tiempo de espera agotado',
  'reports.datasets.error.transientSql': 'Error SQL transitorio',
  'reports.datasets.error.transientStorage': 'Error de almacenamiento transitorio',
  'reports.datasets.error.storageConflict': 'Conflicto de almacenamiento',
  'reports.datasets.error.permanent': 'Error permanente',
  'reports.datasets.error.default': 'Error de sincronización',
  'reports.datasets.error.load': 'No se pudo cargar el inventario de datasets.',
  'reports.datasets.error.forbidden': 'No tienes permiso para ver el inventario de datasets.',
  'reports.datasets.error.powerbi':
    'El inventario de datasets solo está disponible en reportes Native.',
  'reports.datasets.status.aria': 'Resumen operativo',
  'reports.datasets.status.due': '{count} por sincronizar',
  'reports.datasets.status.failed': '{count} con error',
  'reports.datasets.version.published': 'Versión {version} publicada',
  'reports.datasets.version.draft': 'Versión {version} · borrador',
  'reports.datasets.field.stream': 'Stream',
  'reports.datasets.field.schema': 'Esquema',
  'reports.datasets.field.interval': 'Intervalo',
  'reports.datasets.field.intervalValue': '{seconds} segundos',
  'reports.datasets.field.lastData': 'Último dato',
  'reports.datasets.field.lastSync': 'Último sync',
  'reports.datasets.field.lastRebuild': 'Último rebuild',
  'reports.datasets.field.lastReconcile': 'Última reconciliación',
  'reports.datasets.field.node': 'Nodo',
  'reports.datasets.field.process': 'Proceso',
  'reports.datasets.empty.company': 'Todavía no hay datasets sincronizados',
  'reports.datasets.empty.companyHint':
    'Cuando existan filas activas de este ambiente —dimensiones globales o hechos de proceso— aparecerán aquí con su salud y sync.',
  'reports.datasets.empty.report': 'Este reporte aún no declara datasets',
  'reports.datasets.empty.reportHint':
    'Los datasets lógicos del borrador o la versión publicada se listan aquí, aunque todavía no estén materializados.',
  'reports.datasets.empty.search': 'Nada coincide con tu búsqueda',
  'reports.datasets.empty.searchHint': 'Prueba con el nombre, la key o el proceso del dataset.',
  'reports.datasets.files.title': 'Archivos publicados',
  'reports.datasets.files.generation': 'Generación {generation}',
  'reports.datasets.files.empty': 'No hay generación publicada todavía.',
  'reports.datasets.files.notSynced': 'Aún no sincronizado. No hay archivos en el lake.',
  'reports.datasets.files.missing': 'No se encontró el stream de este dataset.',
  'reports.datasets.files.error': 'No se pudo listar los archivos publicados.',
  'reports.datasets.files.kind.parquet': 'Parquet',
  'reports.datasets.files.kind.manifest': 'Manifiesto',
  'reports.datasets.files.download': 'Descargar',
  'reports.datasets.files.downloadError': 'No se pudo descargar el archivo.',
  'reports.datasets.files.preview': 'Ver muestra',
  'reports.datasets.files.previewFile': 'Ver archivo',
  'reports.datasets.files.previewError': 'No se pudo abrir el archivo.',
};
